import { map, Observable } from 'rxjs';
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  Input,
  OnInit,
  ViewChild,
} from '@angular/core';
import { CommentEntityNameEnum, ThreadViewModel } from '../../models';
import { CommentingFacadeService, CommentPanelManagerService, FocusingService } from '../../services';
import { ThreadModel } from '@anecdotes/commenting';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { sanitizeRichText } from '@anecdotes/utils';

@Component({
  selector: 'app-thread-group-comment-view',
  templateUrl: './thread-group-comment-view.component.html',
  styleUrls: ['./thread-group-comment-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ThreadGroupCommentViewComponent implements OnInit, AfterViewInit {
  @ViewChild('threadBody')
  private threadBodyElement: ElementRef<any>;

  @Input()
  threadView: ThreadViewModel;

  repliesCount$: Observable<number>;
  threadHeader$: Observable<ThreadModel>;
  doesOverflowWidth: boolean;

  constructor(
    private commentingFacadeService: CommentingFacadeService,
    private commentPanelManagerService: CommentPanelManagerService,
    private focusingService: FocusingService,
    private domSanitizer: DomSanitizer,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.threadHeader$ = this.commentingFacadeService.getThreadById(this.threadView.threadId);
    this.repliesCount$ = this.commentingFacadeService
      .getCommentsByThreadId(this.threadView.threadId)
      .pipe(map((comments) => comments.length));
  }

  ngAfterViewInit(): void {
    if (this.threadBodyElement?.nativeElement) {
      this.doesOverflowWidth = this.threadBodyElement.nativeElement.clientWidth !== this.threadBodyElement.nativeElement.scrollWidth;
      this.cd.detectChanges();
    }
  }

  buildTranslationKey(relativeKey: string): string {
    return `commenting.${relativeKey}`;
  }

  sanitizeHtml(text: string): SafeHtml {
    text = sanitizeRichText(text);
    return this.domSanitizer.bypassSecurityTrustHtml(text);
  }

  @HostListener('click')
  private focusControl(): void {
    this.commentPanelManagerService.displaySingleThread(this.threadView.resourceType, this.threadView.resourceId);
    this.focusingService.focusResources({ [CommentEntityNameEnum.Comment]: this.threadView.threadId });
  }
}
